module.exports = __webpack_public_path__ + "static/motor-imagery-383d12a7ce1da26838232961bf040b40.jpg";